import React from 'react';
import { SvgIcon, useTheme } from '@mui/material';

export default function CaretRightIcon(props) {
  const theme = useTheme();

  return (
    <SvgIcon inheritViewBox {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="10"
        height="19"
        viewBox="0 0 10 19"
        fill="none"
      >
        <path
          d="M1 17.5L9 9.5L1 1.5"
          stroke={theme?.palette?.text?.button}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
}
